<app-side-menu>
  <div class="detail-page">
    <!-- Cabeçalho -->
    <header class="detail-header">
      <div class="detail-header__main">
        <button type="button" class="btn-back" (click)="goBack()">
          <i class="fas fa-arrow-left"></i> Voltar à lista
        </button>
        <h1 class="detail-title">
          <span class="detail-title__icon"><i class="fas fa-traffic-light"></i></span>
          Detalhe da Multa
        </h1>
      </div>
      <div class="detail-header__badges" *ngIf="fine && !loading">
        <span [class]="infractionStatusClass()">{{ infractionStatus }}</span>
        <span [class]="paymentStatusClass()">{{ paymentStatus }}</span>
      </div>
      <div class="detail-header__actions" *ngIf="fine && !loading">
        <button *ngIf="!isInfractionNotIndicable(infractionInfo.infractionStatus)" type="button" class="btn btn-outline-secondary btn-status" (click)="onChangeStatus()">
          <i class="fas fa-exchange-alt me-2"></i>Alterar Status
        </button>
      </div>
    </header>

    <div *ngIf="error" class="alert alert-danger detail-alert">{{ error }}</div>

    <div *ngIf="loading" class="detail-loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p>Carregando dados da multa...</p>
    </div>

    <ng-container *ngIf="!loading && fine">
      <!-- Resumo -->
      <section class="summary-card" aria-label="Resumo da multa">
        <div class="summary-card__primary">
          <span class="summary-label">Nº AIT</span>
          <span class="summary-ait">{{ aitNumber }}</span>
        </div>
        <div class="summary-card__metrics">
          <div class="summary-metric">
            <span class="summary-label">Placa</span>
            <span class="summary-value">{{ pickDisplay(fine, 'vehiclePlate', 'VehiclePlate', 'plateNumber',
              'PlateNumber', 'plate', 'Plate') }}</span>
          </div>
          <div class="summary-metric">
            <span class="summary-label">Data infração</span>
            <span class="summary-value">{{ formatDate(pickRawDisplay(fine, 'infractionDateTime', 'issueDate',
              'InfractionDateTime', 'IssueDate')) }}</span>
          </div>
          <div class="summary-metric">
            <span class="summary-label">Vencimento</span>
            <span class="summary-value">{{ formatDate(pickRawDisplay(fine, 'dueDate', 'DueDate')) }}</span>
          </div>
          <div class="summary-metric">
            <span class="summary-label">Valor original</span>
            <span class="summary-value">{{ formatCurrency(getOriginalAmount()) }}</span>
          </div>
          <div class="summary-metric summary-metric--amount">
            <span class="summary-label">Valor ao cliente</span>
            <span class="summary-value summary-value--amount">{{ formatCurrency(getDisplayClientAmount()) }}</span>
          </div>
        </div>
      </section>

      <div class="detail-card">
        <ul class="nav nav-tabs detail-tabs" role="tablist">
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'dados'" (click)="selectDetailTab('dados')">
              <i class="fas fa-list me-1"></i> Dados
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'chamado'" (click)="selectDetailTab('chamado')">
              <i class="fas fa-briefcase me-1"></i> Chamado B2B
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'chat'"
              [disabled]="!b2bCase" (click)="selectDetailTab('chat')">
              <i class="fas fa-comments me-1"></i> Chat
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'anexos'"
              [disabled]="!b2bCase" (click)="selectDetailTab('anexos')">
              <i class="fas fa-paperclip me-1"></i> Anexos
              <span class="badge bg-secondary ms-1" *ngIf="b2bEvidences.length">{{ b2bEvidences.length }}</span>
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'email'" (click)="selectDetailTab('email')">
              <i class="fas fa-envelope me-1"></i> E-mail
            </button>
          </li>
        </ul>

        <div class="detail-card__body">
          <app-traffic-fine-email-panel
            *ngIf="detailTab === 'email'"
            [fineId]="id"
            [placa]="pickDisplay(fine, 'vehiclePlate', 'VehiclePlate', 'plateNumber', 'PlateNumber', 'plate', 'Plate')"
            [ait]="aitNumber"
            [contrato]="pickDisplay(fine, 'contractNumber', 'ContractNumber')"
            [pessoa]="pickDisplay(fine, 'customerName', 'CustomerName', 'driverName', 'DriverName')"
            [vencimento]="formatDate(pickRawDisplay(fine, 'dueDate', 'DueDate'))"
            [prazoIndicacao]="formatDate(indicationLimitAt)"
            [dataIndicacao]="formatDate(indicatedAt)"
            [descricao]="pickDisplay(fine, 'description', 'Description')"
            (enviado)="loadHistories()">
          </app-traffic-fine-email-panel>

          <!-- Aba Dados -->
          <div class="detail-grid" *ngIf="detailTab === 'dados'">
            <div class="detail-grid__info">
              <article class="info-section" *ngFor="let section of detailSections" [attr.aria-label]="section.title">
                <h2 class="info-section__title">
                  <i [class]="section.icon + ' me-2'"></i>{{ section.title }}
                </h2>
                <dl class="info-fields">
                  <ng-container *ngFor="let field of section.fields">
                    <dt>{{ field.label }}</dt>
                    <dd [class.info-fields__highlight]="field.highlight">{{ field.value }}</dd>
                  </ng-container>
                </dl>
              </article>

              <!-- Fora do *ngFor: ngModel + getter recriava o DOM e travava a tela -->
              <article class="info-section" aria-label="Valor ao cliente">
                <div class="client-amount-editor">
                  <label class="form-label mb-1">Definir valor cobrado do cliente</label>
                  <p class="small text-muted mb-2">
                    <strong>À vista:</strong> use o valor da infração.
                    Acréscimo (ex.: 2× + R$ 25) só quando for a regra comercial — não confundir com desconto do órgão.
                  </p>
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      style="max-width:160px"
                      step="0.01"
                      min="0.01"
                      [(ngModel)]="clientAmountDraft"
                      [disabled]="clientAmountBusy" />
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      [disabled]="clientAmountBusy || clientAmountDraft == null"
                      (click)="saveClientAmount()">
                      <span *ngIf="clientAmountBusy" class="spinner-border spinner-border-sm me-1"></span>
                      Salvar valor ao cliente
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      [disabled]="clientAmountBusy || getOriginalAmount() <= 0"
                      (click)="useInfractionAmountAsClientCharge()">
                      Usar valor da infração (à vista)
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-link"
                      [disabled]="clientAmountBusy"
                      (click)="clientAmountDraft = getChargePreview(2)">
                      Sugerir 2× + R$ 25
                    </button>
                  </div>
                </div>
                <div class="info-section__actions" *ngIf="canGenerateCharge()">
                  <button type="button" class="btn btn-primary" (click)="openChargeModal()">
                    <i class="fas fa-file-invoice-dollar me-2"></i>Gerar Cobrança
                  </button>
                </div>
                <div class="charge-already-generated" *ngIf="hasExistingCharge()">
                  <i class="fas fa-check-circle me-2"></i>Cobrança já gerada para esta multa.
                </div>
              </article>
            </div>

            <aside class="detail-grid__history" aria-label="Histórico da multa">
              <div class="history-card">
                <div class="history-card__header">
                  <h2 class="history-card__title">
                    <i class="fas fa-history me-2"></i>
                    Histórico
                    <span class="history-card__count">({{ history.length }})</span>
                  </h2>
                </div>

                <div *ngIf="historyError" class="alert alert-warning mx-3 mb-2" role="alert">
                  <i class="fas fa-exclamation-triangle me-2"></i>{{ historyError }}
                </div>

                <div class="history-loading" *ngIf="historyLoading">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Carregando histórico...</span>
                  </div>
                  <p>Carregando histórico...</p>
                </div>

                <div class="historico-timeline" *ngIf="!historyLoading && history.length > 0">
                  <div class="timeline-item" *ngFor="let evento of history; trackBy: trackByHistory">
                    <div class="timeline-marker" [style.background-color]="historyMarkerColor(evento.tipo)"
                      [attr.title]="evento.tipo">
                      <i class="fas" [class]="historyIcon(evento.tipo)"></i>
                    </div>
                    <div class="timeline-content">
                      <div class="timeline-header">
                        <h3 class="timeline-title">{{ evento.description }}</h3>
                        <time class="timeline-date">{{ formatDateTime(evento.date) }}</time>
                      </div>
                      <p class="timeline-status" *ngIf="evento.status">
                        <span [class]="historyStatusClass(evento.status)">{{ evento.status }}</span>
                      </p>
                      <p class="timeline-user" *ngIf="evento.usuario">
                        <i class="fas fa-user me-1"></i>{{ evento.usuario }}
                      </p>
                      <p class="timeline-details" *ngIf="evento.detalhes">{{ evento.detalhes }}</p>
                    </div>
                  </div>
                </div>

                <div class="historico-empty" *ngIf="!historyLoading && !historyError && history.length === 0">
                  <div style="width: 100%; display: flex;">
                    <i class="fas fa-clock" style="margin: auto;"></i>
                  </div>
                  <p>Nenhum evento registrado para esta multa.</p>
                </div>
              </div>
            </aside>
          </div>

          <!-- Aba Chamado B2B -->
          <div *ngIf="detailTab === 'chamado'" class="tab-panel">
            <div *ngIf="b2bCaseLoading" class="text-muted small">Carregando chamado…</div>
            <div *ngIf="!b2bCaseLoading && !b2bCase">
              <p class="small text-muted mb-2">
                Sem vínculo B2B: escolha o <strong>cliente jurídico / contrato ativo</strong> para listar a multa na aba Multas do portal.
              </p>

              <div class="mb-2" *ngIf="b2bContractsLoading">
                <span class="spinner-border spinner-border-sm me-1"></span>
                <span class="small text-muted">Carregando contratos ativos…</span>
              </div>

              <div class="d-flex flex-column gap-2" style="max-width:520px" *ngIf="!b2bContractsLoading">
                <input
                  type="search"
                  class="form-control form-control-sm"
                  [(ngModel)]="b2bContractsFilter"
                  placeholder="Filtrar por empresa, CNPJ ou número do contrato…" />

                <select
                  class="form-select form-select-sm"
                  [(ngModel)]="selectedAssignContractId"
                  (ngModelChange)="onAssignContractSelected()">
                  <option [ngValue]="null">Selecione o contrato B2B…</option>
                  <option *ngFor="let c of filteredB2bContractsForAssign" [ngValue]="c.id">
                    {{ b2bContractOptionLabel(c) }}
                  </option>
                </select>

                <p class="small text-muted mb-0" *ngIf="!filteredB2bContractsForAssign.length">
                  Nenhum contrato encontrado com esse filtro.
                </p>

                <details class="small text-muted">
                  <summary>Ou informar Id / número manualmente</summary>
                  <input
                    type="text"
                    class="form-control form-control-sm mt-2"
                    style="max-width:280px"
                    [(ngModel)]="assignContractInput"
                    placeholder="B2B-2026-804714 ou Id" />
                </details>

                <div>
                  <button type="button" class="btn btn-sm btn-primary"
                    [disabled]="b2bCaseBusy || !assignContractInput?.trim()"
                    (click)="assignB2bCase()">
                    Atribuir ao contrato B2B
                  </button>
                </div>
              </div>

              <div *ngIf="assignContractPreview" class="small text-success mt-1">{{ assignContractPreview }}</div>
              <div *ngIf="b2bCaseError" class="text-danger small mt-2">{{ b2bCaseError }}</div>
            </div>
            <div *ngIf="!b2bCaseLoading && b2bCase">
              <div class="alert alert-success" role="status">
                Multa da placa <strong>{{ b2bCase.vehiclePlate || '—' }}</strong>
                vinculada ao contrato <strong>{{ b2bCase.contractNumber || b2bCase.b2BContractId }}</strong>.
              </div>
              <dl class="info-fields mb-3" style="max-width:420px">
                <dt>Case #</dt><dd>{{ b2bCase.id }}</dd>
                <dt>Contrato</dt><dd>{{ b2bCase.contractNumber || b2bCase.b2BContractId }}</dd>
                <dt>Placa</dt><dd>{{ b2bCase.vehiclePlate || '—' }}</dd>
                <dt>Status</dt><dd><strong>{{ b2bCase.status }}</strong></dd>
                <dt>Aberto em</dt><dd>{{ formatDate(b2bCase.openedAt) }}</dd>
              </dl>
              <div class="d-flex gap-2 flex-wrap mb-2">
                <select class="form-select form-select-sm" style="max-width:220px" [(ngModel)]="b2bStatusTarget">
                  <option value="">Novo status…</option>
                  <option *ngFor="let s of b2bCaseStatuses" [value]="s">{{ s }}</option>
                </select>
                <button type="button" class="btn btn-sm btn-outline-secondary"
                  [disabled]="b2bCaseBusy || !b2bStatusTarget"
                  (click)="transitionB2bStatus()">Atualizar status</button>
              </div>
              <div *ngIf="b2bCaseError" class="text-danger small">{{ b2bCaseError }}</div>
              <p class="small text-muted mt-3 mb-0">
                Use as abas <strong>Chat</strong> e <strong>Anexos</strong> para conversar com o portal e anexar comprovantes.
              </p>
            </div>
          </div>

          <!-- Aba Chat -->
          <div *ngIf="detailTab === 'chat'" class="tab-panel">
            <div *ngIf="!b2bCase" class="text-muted">Atribua o chamado B2B antes de usar o chat.</div>
            <ng-container *ngIf="b2bCase">
              <div class="b2b-chat-list mb-3">
                <div *ngIf="!b2bComments.length" class="small text-muted">Nenhuma mensagem.</div>
                <div *ngFor="let c of b2bComments" class="b2b-chat-bubble mb-2">
                  <strong>{{ c.autor }}</strong>
                  <span class="text-muted small">({{ c.autorOrigem }}{{ c.interno ? ' · interno' : '' }})</span>
                  <div>{{ c.mensagem }}</div>
                  <div class="text-muted small">{{ formatDate(c.criadoEm) }}</div>
                </div>
              </div>
              <div class="d-flex gap-2 align-items-start">
                <textarea class="form-control" rows="3" [(ngModel)]="b2bCommentDraft"
                  placeholder="Mensagem para o cliente…"></textarea>
                <div class="d-flex flex-column gap-1">
                  <label class="small mb-0"><input type="checkbox" [(ngModel)]="b2bCommentInternal" /> Interno</label>
                  <button type="button" class="btn btn-primary" [disabled]="b2bCaseBusy || !b2bCommentDraft?.trim()"
                    (click)="sendB2bComment()">Enviar</button>
                </div>
              </div>
              <div *ngIf="b2bCaseError" class="text-danger small mt-2">{{ b2bCaseError }}</div>
            </ng-container>
          </div>

          <!-- Aba Anexos -->
          <div *ngIf="detailTab === 'anexos'" class="tab-panel">
            <div *ngIf="!b2bCase" class="text-muted">Atribua o chamado B2B antes de anexar arquivos.</div>
            <ng-container *ngIf="b2bCase">
              <div class="d-flex align-items-center gap-2 flex-wrap mb-3">
                <label class="btn btn-outline-primary btn-sm mb-0" [class.disabled]="b2bEvidenceBusy">
                  <i class="fas" [class.fa-upload]="!b2bEvidenceBusy" [class.fa-spinner]="b2bEvidenceBusy" [class.fa-spin]="b2bEvidenceBusy"></i>
                  {{ b2bEvidenceBusy ? 'Enviando…' : 'Anexar arquivo' }}
                  <input type="file" hidden [disabled]="b2bEvidenceBusy" (change)="onEvidenceFileSelected($event)" />
                </label>
                <span class="small text-muted">Fotos e documentos ficam visíveis no portal do cliente.</span>
              </div>
              <div *ngIf="b2bCaseError" class="text-danger small mb-2">{{ b2bCaseError }}</div>
              <div *ngIf="!b2bEvidences.length" class="text-muted small">Nenhum anexo nesta multa.</div>
              <ul class="evidence-list" *ngIf="b2bEvidences.length">
                <li *ngFor="let e of b2bEvidences" class="evidence-item">
                  <a *ngIf="e.filePath; else noLink" [href]="e.filePath" target="_blank" rel="noopener" class="evidence-link">
                    <i class="fas" [class.fa-image]="isEvidenceImage(e)" [class.fa-file]="!isEvidenceImage(e)"></i>
                    {{ e.fileName }}
                  </a>
                  <ng-template #noLink>
                    <span><i class="fas fa-file me-1"></i>{{ e.fileName }}</span>
                  </ng-template>
                  <span class="evidence-meta text-muted small">
                    {{ e.uploadedBy || '—' }} · {{ formatDate(e.uploadDate) }}
                    <ng-container *ngIf="e.fileSize"> · {{ formatEvidenceSize(e.fileSize) }}</ng-container>
                  </span>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Modal de Seleção de Status -->
  <app-modal [isOpen]="showStatusSelectionModal" [title]="'Alterar Status da Multa'" [size]="'md'" [closable]="true"
    (close)="closeStatusModal()">
    <div class="py-3">
      <p class="text-muted mb-3" *ngIf="fine">
        Selecione o novo status para <strong>{{ pickDisplay(fine, 'aipNumber', 'AIPNumber') }}</strong>.
      </p>

      <div class="status-grid">
        <button type="button" class="traffic-fine-status-option"
          [class.traffic-fine-status-option--selected]="statusModalSelectedStatus === status"
          *ngFor="let status of availableStatuses" (click)="selectStatusFromModal(status)"
          [disabled]="statusModalLoading">
          <i class="fas fa-check me-2" *ngIf="statusModalSelectedStatus === status"></i>
          {{ status }}
        </button>
      </div>
      <div *ngIf="statusModalError" class="alert alert-danger mt-3">{{ statusModalError }}</div>
    </div>

    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeStatusModal()" [disabled]="statusModalLoading">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
    </div>
  </app-modal>

  <!-- Modal Gerar Cobrança -->
  <app-modal [isOpen]="showChargeModal" [title]="'Gerar Cobrança'" [size]="'lg'" [closable]="true"
    (close)="closeChargeModal()">
    <div class="py-2">
      <div class="charge-summary mb-3" *ngIf="fine">
        <div class="charge-summary__row">
          <span class="charge-summary__label">Nº AIT</span>
          <span class="charge-summary__value">{{ aitNumber }}</span>
        </div>
        <div class="charge-summary__row">
          <span class="charge-summary__label">Vencimento</span>
          <span class="charge-summary__value">{{ formatDate(pickRawDisplay(fine, 'dueDate', 'DueDate')) }}</span>
        </div>
        <div class="charge-summary__row">
          <span class="charge-summary__label">Valor original</span>
          <span class="charge-summary__value">{{ formatCurrency(getOriginalAmount()) }}</span>
        </div>
        <div class="charge-summary__row charge-summary__row--highlight">
          <span class="charge-summary__label">Valor ao cliente (selecionado)</span>
          <span class="charge-summary__value">{{ formatCurrency(getSelectedChargeAmount()) }}</span>
        </div>
        <div class="charge-summary__row">
          <span class="charge-summary__label">Cliente</span>
          <span class="charge-summary__value">{{ pickDisplay(fine, 'customerName', 'CustomerName') }}</span>
        </div>
      </div>

      <div *ngIf="chargeModalLoading" class="text-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="text-muted mt-2 mb-0">Carregando dados do condutor...</p>
      </div>

      <ng-container *ngIf="!chargeModalLoading">
        <div class="charge-driver-block mb-3">
          <h3 class="charge-section-title">
            <i class="fas fa-user me-2"></i>Condutor
          </h3>
          <div class="charge-driver-summary" *ngIf="hasDriverInfo(); else noDriver">
            <div class="charge-driver-summary__item">
              <span class="charge-driver-summary__label">Nome</span>
              <span class="charge-driver-summary__value">{{ driverInfo?.name }}</span>
            </div>
            <div class="charge-driver-summary__item">
              <span class="charge-driver-summary__label">CPF</span>
              <span class="charge-driver-summary__value">{{ driverInfo?.cpf || '—' }}</span>
            </div>
            <div class="charge-driver-summary__item">
              <span class="charge-driver-summary__label">RG</span>
              <span class="charge-driver-summary__value">{{ driverInfo?.rg || '—' }}</span>
            </div>
            <div class="charge-driver-summary__item charge-driver-summary__item--wide">
              <span class="charge-driver-summary__label">Endereço</span>
              <span class="charge-driver-summary__value">{{ driverInfo?.address || '—' }}</span>
            </div>
            <div class="charge-driver-summary__item">
              <span class="charge-driver-summary__label">Cidade / UF</span>
              <span class="charge-driver-summary__value">
                {{ driverInfo?.city || '—' }} / {{ driverInfo?.state || '—' }}
              </span>
            </div>
          </div>
          <ng-template #noDriver>
            <p class="charge-driver-empty mb-0">
              <i class="fas fa-info-circle me-2"></i>Nenhum condutor indicado para esta multa.
            </p>
          </ng-template>
        </div>

        <div class="charge-options-block">
          <h3 class="charge-section-title">
            <i class="fas fa-calculator me-2"></i>Opção de cobrança
          </h3>
          <p class="text-muted small mb-3">
            Todas as opções incluem acréscimo de R$ 25,00. O valor escolhido será gravado como
            <strong>valor cobrado do cliente</strong> (visível no portal B2B).
          </p>
          <div class="status-grid charge-options-grid">
            <button type="button" class="traffic-fine-status-option charge-option"
              [class.traffic-fine-status-option--selected]="selectedChargeMultiplier === option.multiplier"
              *ngFor="let option of chargeOptions" (click)="selectChargeMultiplier(option.multiplier)"
              [disabled]="chargeModalSubmitting">
              <span class="charge-option__label">{{ option.label }}</span>
              <span class="charge-option__subtitle">{{ option.subtitle }}</span>
              <span class="charge-option__amount">{{ formatCurrency(getChargePreview(option.multiplier)) }}</span>
            </button>
          </div>
        </div>

        <div *ngIf="!getCustomerId()" class="alert alert-warning mt-3 mb-0">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Esta multa não possui cliente vinculado. Vincule um cliente na listagem antes de gerar a cobrança.
        </div>
        <div *ngIf="chargeModalError" class="alert alert-danger mt-3 mb-0">{{ chargeModalError }}</div>
      </ng-container>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeChargeModal()"
        [disabled]="chargeModalSubmitting">
        <i class="fas fa-times me-2"></i>Cancelar
      </button>
      <button type="button" class="btn btn-primary" (click)="confirmGenerateCharge()"
        [disabled]="!canConfirmCharge()">
        <span *ngIf="chargeModalSubmitting" class="spinner-border spinner-border-sm me-2" role="status"
          aria-hidden="true"></span>
        <i *ngIf="!chargeModalSubmitting" class="fas fa-check me-2"></i>
        Gerar Cobrança
      </button>
    </div>
  </app-modal>
</app-side-menu>
